<p mat-dialog-title>{{ 'common.CONTACT' | translate }}</p>
<form
  mat-dialog-content
  class="contact-form"
  id="contact-form"
  [formGroup]="contactFormGroup"
  (ngSubmit)="sendMessage()">
  <mat-form-field>
    <mat-label>{{ 'contact.YOUR_NAME' | translate }}</mat-label>
    <input
      matInput
      formControlName="name"
      type="text"
      autocomplete="name"
      [placeholder]="'contact.YOUR_NAME' | translate" />
    @if (contactFormGroup.controls.name.hasError('required')) {
      <mat-error>
        {{ 'contact.YOUR_NAME_REQUIRED' | translate }}
      </mat-error>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'contact.YOUR_MAIL_ADDRESS' | translate }}</mat-label>
    <input
      matInput
      formControlName="email"
      [placeholder]="'contact.YOUR_MAIL_ADDRESS' | translate" />
    @if (
      contactFormGroup.controls.email.hasError('email') &&
      !contactFormGroup.controls.email.hasError('required')
    ) {
      <mat-error>
        {{ 'contact.YOUR_MAIL_ADDRESS_VALID' | translate }}
      </mat-error>
    }
    @if (contactFormGroup.controls.email.hasError('required')) {
      <mat-error>
        {{ 'contact.YOUR_MAIL_ADDRESS_REQUIRED' | translate }}
      </mat-error>
    }
  </mat-form-field>
  <mat-form-field class="contact-form__message">
    <mat-label>{{ 'contact.YOUR_MESSAGE' | translate }}</mat-label>
    <textarea
      matInput
      formControlName="message"
      [placeholder]="'contact.YOUR_MESSAGE' | translate"></textarea>
    @if (contactFormGroup.controls.message.hasError('required')) {
      <mat-error>
        {{ 'contact.YOUR_MESSAGE_REQUIRED' | translate }}
      </mat-error>
    }
  </mat-form-field>
</form>
<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="closeDialog()">
    {{ 'common.BUTTON_ABORT' | translate }}
  </button>
  <button
    mat-flat-button
    color="primary"
    type="submit"
    form="contact-form"
    [disabled]="(isLoading$ | async) === true || contactFormGroup.invalid">
    @if ((isLoading$ | async) === false) {
      {{ 'common.BUTTON_OK' | translate }}
    } @else {
      <mat-spinner diameter="20"></mat-spinner>
    }
  </button>
</div>
